import { createContext, useContext } from "react";

export const ModalContext = createContext<{ [key: string]: any }>({})

export const useModalContext = () => useContext(ModalContext)


